import * as REPORT_ACTION from 'js/constant/action/report'
import { createAction } from 'redux-actions'
import _ from 'lodash'
import { getReports } from 'js/redux/api/report'

const updateLoader = createAction(REPORT_ACTION.UPDATE_REPORT_LOADER)
const updateReportData = createAction(REPORT_ACTION.UPDATE_REPORT_DATA)

export const getReportsData =
    (targetData) =>
      async (dispatch, getState, { report }) => {
        try {
          dispatch(updateLoader(true))

          const data = await getReports()

          const reports = data.map((item) => ({
            contact_detail: item.code,
            contact_type: item.label,
            claims_value: item.total_return_value,
            number_of_returns: item.number_of_refunds
          }))

          if (reports) {
            dispatch(updateReportData(_.orderBy(reports, ['total_return_value', 'number_of_refunds'], ['desc', 'desc'])))
            dispatch(updateLoader(false))
          }
        } catch (error) {
          dispatch(updateLoader(false))
          console.error(error)
        }
      }
